import React from 'react';
import OverLap1 from '../../assets/images/ico_overlap1.png';
import OverLap2 from '../../assets/images/ico_overlap2.png';
import OverLap3 from '../../assets/images/ico_overlap3.png';
import OverLap4 from '../../assets/images/ico_overlap4.png';
import OverLap5 from '../../assets/images/ico_overlap5.png';
import { TrainsType } from '../../apis/Transits.api';

interface props {
  trainsData: {
    spotId: string;
    trains: TrainsType[];
  };
  setDetailDisp: React.Dispatch<React.SetStateAction<TrainsType[] | undefined>>;
}

const TrainColor = (course: number) => {
  switch (course) {
    case 1:
      return OverLap1;
    case 2:
      return OverLap2;
    case 3:
      return OverLap3;
    case 4:
      return OverLap4;
    case 5:
      return OverLap5;
  }
};

export const OverlapTrain: React.FC<props> = (props) => {
  const data = props.trainsData;
  const setDetailDisp = props.setDetailDisp;

  return (
    <g onClick={() => setDetailDisp(data.trains)} cursor='pointer'>
      <image
        key={`${'overlapTrain' + data.spotId}`}
        x={data.trains[0].x - 13}
        y={data.trains[0].y - 87}
        xlinkHref={TrainColor(data.trains[0].course)}
      ></image>
      <text
        fontSize='17'
        x={
          data.trains.length < 10
            ? data.trains[0].x - 4
            : data.trains[0].x - 9.2
        }
        y={data.trains[0].y - 67}
        fill='white'
      >
        {data.trains.length}
      </text>
    </g>
  );
};
